var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('div',{staticClass:"login-form"},[_c('div',{staticClass:"pa-4 text-center",attrs:{"id":"drawer-wrapper"}},[_c('v-img',{attrs:{"max-width":"270","src":"/logo.png"}})],1),_c('v-btn',{attrs:{"color":"secondary","large":"","loading":_vm.loading},on:{"click":_vm.handleLogin}},[_vm._v("Sign in")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }